import { createContext, Dispatch } from 'react';

import { EventRequest, GlobalLotsUiConfigKeys, LineItemsState } from 'types';

import { LineItemsAction, LotCardHeaderChangesAction } from './action_types';
import { defaultLineItemsState } from './defaultLineItemsState';

export interface UiConfigChanges {
  key: keyof GlobalLotsUiConfigKeys;
  value: boolean;
}

export interface ApplyLineItemSettingsPayload {
  anchorPricingDisabled?: boolean;
  serveSingleSupplierQuoteFeedback?: boolean;
  supplierQuantityEnabled?: boolean;
  uiConfigAnchorPrices?: { max_discount?: number | null };
  uiConfigLots?: Partial<Record<keyof GlobalLotsUiConfigKeys, boolean>>;
}

export interface LineItemsContextProps {
  dispatch: Dispatch<LineItemsAction>;
  handleApplyLineItemSettings: (_payload: ApplyLineItemSettingsPayload) => Promise<void>;
  handleChangeLot: (_changes: LotCardHeaderChangesAction['payload']) => void;
  handleSaveChanges: (options?: { skipBaselineWarning?: boolean }) => void;
  handleUpdateServeSingleSupplierQuoteFeedback: (_value: boolean) => void;
  handleUpdateSupplierQuantityEnabled: (_value: boolean) => void;
  handleUpdateUiConfig: (_changes: UiConfigChanges) => void;
  hasChanges: boolean;
  hasErrors: boolean;
  hasSuccess: boolean;
  nsbEnabled: boolean;
  request: EventRequest;
  state: LineItemsState;
}

/** Keep this leaf context free of provider, reducer, action, and renderer imports to avoid cycles. */
export const LineItemsContext = createContext<LineItemsContextProps>({
  dispatch: (_value: LineItemsAction): void => { /** empty */ },
  handleApplyLineItemSettings: async (_payload: ApplyLineItemSettingsPayload) => { /** empty */ },
  handleChangeLot: (_changes: LotCardHeaderChangesAction['payload']) => { /** empty */ },
  handleSaveChanges: () => { /** empty */ },
  handleUpdateServeSingleSupplierQuoteFeedback: (_value: boolean) => { /** empty */ },
  handleUpdateSupplierQuantityEnabled: (_value: boolean) => { /** empty */ },
  handleUpdateUiConfig: (_changes: UiConfigChanges) => { /** empty */ },
  hasChanges: false,
  hasErrors: false,
  hasSuccess: false,
  nsbEnabled: false,
  request: {} as EventRequest,
  state: defaultLineItemsState,
});
